import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { getCommentsOfNew, getNew } from '../../feature/api/news'
import {  Grid, Skeleton, Typography } from '@mui/material'
import Comment from './Comment'
import Comments from './Comments'

const New = () => {
    const dispatch = useDispatch()
    const {id} = useParams()
    const newDetails = useSelector(state => state.news.new)
    const isLoadingNew = useSelector(state => state.news.isLoadingNew)
    const comments = useSelector(state => state.news.comments)
    useEffect(()=>{
        dispatch(getNew(id))
        dispatch(getCommentsOfNew(id))
    },[])
    useEffect(()=>{
      newDetails?.map((item) =>{
        const scriptEl = document.createRange().createContextualFragment(item.Text);
        const p = document.getElementById("text")
        p.append(scriptEl);
      })
    },[newDetails])
    
  return (
    <Grid container width={"100%"} p="10px" display={"flex"} justifyContent={"center"} bgcolor={'#000'}>
        {
        isLoadingNew ? 
        <Grid  item lg={8} xl={8} display={"flex"} flexDirection={"column"} gap={2} p="10px " >
          <Skeleton variant="rectangular" width="100%" sx={{ bgcolor: 'grey.300',borderRadius:'50px'}}/>
          <Skeleton variant="rectangular" width="100%" sx={{ bgcolor: 'grey.300',borderRadius:'50px'}}/>
          <Skeleton variant="rectangular" width="100%" sx={{ bgcolor: 'grey.300',borderRadius:'50px'}}/>

          <Skeleton  animation="wave" variant="rectangular" sx={{ bgcolor: 'grey.300',height: 400}}/>
          <Skeleton variant="rectangular" width="100%" sx={{ bgcolor: 'grey.300',borderRadius:'50px'}}/>
          <Skeleton variant="rectangular" width="100%" sx={{ bgcolor: 'grey.300',borderRadius:'50px'}}/>
          <Skeleton variant="rectangular" width="100%" sx={{ bgcolor: 'grey.300',borderRadius:'50px'}}/>


        </Grid>

        :newDetails?.map((item) =>
        <Grid key={item.Id} item lg={8} xl={8} display={"flex"} flexDirection={"column"} gap={2} p="10px "  >
            <Typography color="#EF7C00" fontSize={"42px"} fontWeight={700} textAlign={"center"}>{item?.Title}</Typography>
            <Typography  variant="caption" color="#fff">{item?.Date}</Typography>
            <Typography  variant="caption" color="#fff">{item?.Brif}</Typography>
           { item.Image &&<img src={item.Image} alt={item.Title} width="100%" />}
            {/* <div style={{color:'#fff'}} dangerouslySetInnerHTML={{__html: item.Text}}/> */}
            {/* <div id="33037759781"><script type="text/JavaScript" src="https://www.aparat.com/embed/tk7Px?data[rnddiv]=33037759781&data[responsive]=yes"></script></div> */}
            <p id={"text"} style={{color:"#fff",textAlign:"justify" }} />
        </Grid>
        )}
         <Grid item lg={8} xl={8} display={"flex"} flexDirection={"column"} gap={2} >
            <Comments commets={comments} />
            <Comment id={id} />
         </Grid>
    </Grid>
  )
}

export default New